import React from "react";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
import { PeekDialog } from "@piiqtechnologies/ui-components";
import { CreateOrEditCommunityForm } from "@components/admin/common/community";
export const AddCommunityForm = ({ onClose }) => {
    const intl = useIntl();
    const handleCommunityCreation = () => {
        onClose();
    };
    return (React.createElement(PeekDialog, { disablePortal: true, maxWidth: "sm", hasCloseIcon: true, fullWidth: true, title: intl.formatMessage(messages.communityTitle), open: true, onClose: onClose },
        React.createElement(CreateOrEditCommunityForm, { isCommunityCreation: true, onSubmit: handleCommunityCreation })));
};
export default AddCommunityForm;
